// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v20.0.11-0-g6de8acd",
    "hash": "g6de8acd",
    "distance": 0,
    "tag": "v20.0.11",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v20.0.11",
        "major": 20,
        "minor": 0,
        "patch": 11,
        "prerelease": [],
        "build": [],
        "version": "20.0.11"
    },
    "suffix": "0-g6de8acd",
    "semverString": "20.0.11",
    "version": "20.0.11",
    "date": "2026-03-16T20:37:57.359Z"
};
/* tslint:enable */
